import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'
import { Commodity } from '@/hooks'

export function applyStandardUOM(
    commodityId: number,
    commodities: Commodity[] | undefined,
    activeFilters: ReportFiltersValues,
    onChange: (field: keyof ReportFiltersValues, value: number[]) => void
) {
    const selectedCommodity = commodities?.find(
        (c) => c.commodityTypeId === commodityId
    )

    const standardUom = selectedCommodity?.unitsOfMeasure.find(
        (u) => u.isStandardUnit
    )

    const currentUom = activeFilters.unitOfMeasureId?.[0]

    if (
        standardUom &&
        (activeFilters.unitOfMeasureId?.length === 0 ||
            currentUom !== standardUom.unitOfMeasureId)
    ) {
        onChange('unitOfMeasureId', [standardUom.unitOfMeasureId])
    }
}
